module.exports = __webpack_public_path__ + "static/fbpropak-9739858429d2a89a9d80884579c24af1.png";